import * as React from 'react';
import { SGBase, SGBaseProps } from './sgbase';
import bind from 'bind-decorator';
import { SgNode, CreateSgNode, FullyQualifyIDIfNeeded, TraversalState, BuildSgNodeReturn } from './sgproto';


interface MountableProps extends SGBaseProps
{
}

export class Mountable extends SGBase<MountableProps, null>
{
	constructor( props: any )
	{
		super( props );
		super.setBuildNodeOverride( this.buildNode );
	}

	public getNodeType(): string
	{
		return "mountable";
	}

	@bind private buildNode( traversalState: TraversalState, domNode: HTMLElement ): BuildSgNodeReturn
	{
		return [traversalState, this.createSgNode( domNode )];
	}

}


interface MountedSceneGraphProps extends SGBaseProps
{
	mountedId: string;
}

export class MountedSceneGraph extends SGBase<MountedSceneGraphProps, null>
{
	constructor( props: any )
	{
		super( props );
		super.setBuildNodeOverride( this.buildNode );
	}

	public getNodeType(): string
	{
		return "mountedscenegraph";
	}

	@bind private buildNode( traversalState: TraversalState, domNode: HTMLElement ): BuildSgNodeReturn
	{
		const node = this.createSgNode( domNode );
		node.properties.mountable_id = FullyQualifyIDIfNeeded( this.props.mountedId );
		return [traversalState, node];
	}
}
